import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import api, { apiErr } from "../lib/api";

export default function FunnelRegistrations({ selection, days, onClose }) {
  const [page, setPage] = useState(1);
  const [retry, setRetry] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    setLoading(true); setError(""); setData(null);
    api.get("/admin/funnel/registrations", { params: {
      days, page, scope: selection.scope, group: selection.group,
    } }).then(({ data: result }) => { if (!cancelled) setData(result); })
      .catch((e) => { if (!cancelled) setError(apiErr(e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [days, page, retry, selection]);
  const pages = Math.max(1, Math.ceil((data?.total || 0) / (data?.page_size || 25)));
  return <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="max-w-5xl max-h-[85vh] overflow-y-auto" data-testid="funnel-registrations">
      <DialogHeader>
        <DialogTitle>{selection.title}</DialogTitle>
        <DialogDescription>
          {selection.scope === "unattributed"
            ? `Usuarios registrados en los últimos ${days} días sin una visita atribuida.`
            : `Usuarios vinculados a visitas de los últimos ${days} días, aunque se registraran después.`}
        </DialogDescription>
      </DialogHeader>
      {loading && <p role="status" className="flex items-center gap-2 py-6 text-sm text-slate-500"><Loader2 size={18} className="animate-spin" /> Cargando registros…</p>}
      {error && <div role="alert" className="rounded-lg bg-rose-50 p-3 text-sm text-rose-700">{error}
        <button onClick={() => setRetry((v) => v + 1)} className="ml-3 underline">Reintentar</button>
      </div>}
      {!loading && !error && data && <>
        <p className="text-sm text-slate-600">{data.total.toLocaleString("es-ES")} usuarios</p>
        <div className="overflow-x-auto"><table className="w-full text-left text-sm">
          <thead className="border-b text-xs text-slate-500"><tr>{["Usuario", "Registro", "Procedencia / anuncio", "Suscripción"].map((label) => <th key={label} className="p-2">{label}</th>)}</tr></thead>
          <tbody>{data.users.map((user) => {
            const origin = user.acquisition;
            return <tr key={user.id} className="border-b border-slate-100">
              <td className="p-2"><Link to={`/admin/users/${user.id}`} className="font-medium text-blue-700 underline underline-offset-2">{user.name || user.email || "Ver ficha"}</Link>
                {user.name && <p className="text-xs text-slate-500">{user.email}</p>}</td>
              <td className="p-2 whitespace-nowrap">{user.created_at ? new Date(user.created_at).toLocaleString("es-ES", { dateStyle: "short", timeStyle: "short" }) : "—"}</td>
              <td className="p-2">{!origin ? <span className="text-slate-500">Sin atribución</span> : <>
                <p>{origin.source === "direct_or_unknown" ? "Directa / desconocida" : origin.source || "Desconocida"}</p>
                <p className="text-xs text-slate-500">{origin.campaign_name || origin.utm_campaign || origin.campaign_id || "Sin campaña"}</p>
                <p className="text-xs text-slate-500">{origin.ad_name || origin.utm_content || origin.ad_id || "Sin anuncio identificado"}</p>
              </>}</td>
              <td className="p-2"><p className={user.has_paid ? "text-emerald-700" : "text-slate-500"}>{user.has_paid ? "Ha contratado" : "Sin contratación pagada"}</p>
                <p className="text-xs text-slate-500">Plan actual: {user.plan || "gratis"}</p></td>
            </tr>;
          })}</tbody>
        </table></div>
        {!data.users.length && <p className="py-4 text-center text-sm text-slate-500">No hay registros para esta selección.</p>}
        <div className="flex items-center justify-between gap-3 text-sm">
          <button onClick={() => setPage((v) => v - 1)} disabled={page <= 1} className="rounded-lg border px-3 py-2 disabled:opacity-40">Anterior</button>
          <span>Página {page} de {pages}</span>
          <button onClick={() => setPage((v) => v + 1)} disabled={page >= pages} className="rounded-lg border px-3 py-2 disabled:opacity-40">Siguiente</button>
        </div>
      </>}
    </DialogContent>
  </Dialog>;
}
